export default {
  strings: {
    // Shown in the Informer if an upload is being canceled because it stalled for too long.
    uploadStalled:
      'Upload has not made any progress for %{seconds} seconds. You may want to retry it.',
  },
}
